<template>
    <div class="tab-content p-2 text-center" v-if="!isLoaded">
        {{ $t('loading') }}
    </div>
    <div v-else>
        <div class="mx-auto col-lg-4 col-md-6 col-sm-12 header-margin">
            <div class="text-center p-2 mb-4">
                <h3>AUBE</h3>
                <p>{{ $t('aube_quest.dashboard.title') }}</p>
            </div>
            <div class="form-group text-left">
                <label>{{ $t('aube_quest.dashboard.logged_in') }}</label>
                <div class="form-control">{{ email }}</div>
            </div>
            <div class="integration-box mt-3">
                <small class="text-muted d-block mb-2">{{
                        $t('aube_quest.dashboard.external_service_integration_status')
                    }}</small>
                <div class="integration-item border rounded p-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <strong>Quest</strong>
                            <div class="text-muted small">{{ $t('aube_quest.dashboard.not_linked') }}</div>
                        </div>
                        <span class="text-muted small">{{
                                $t('aube_quest.dashboard.connect_from_quest_side')
                            }}</span>
                    </div>
                </div>
            </div>

            <div class="note mt-3 text-muted small">
                {{ $t('aube_quest.dashboard.note') }}
            </div>
        </div>
    </div>
</template>

<script>
import UserService from '../../../services/UserService';

export default {
    name: "Dashboard",
    data() {
        return {
            isLoaded: false,
            email: null,
        }
    },
    created() {
        this.getEmail();
    },
       methods: {
        async getEmail() {

            try {
                const data = await UserService.getUserFrontendData();
                
                this.email = data.data.email;
                this.isLoaded = true;
            } catch (e) {
                this.isLoaded = true;
            } finally {
            }
        },
    }
};
</script>

<style scoped>

.integration-box {
    background-color: #f8f9fa;
    padding: 15px;
    border-radius: 4px;
}

.integration-item {
    background-color: #fff;
}

.note {
    background-color: #f8f9fa;
    padding: 10px;
    border-radius: 4px;
}
</style>
